import { useRecoilValue } from 'recoil'
import authAtom from '../auth.atom.ts'

const useAccessToken = () => {
  const state = useRecoilValue(authAtom)

  return state.accessToken
}

export default useAccessToken
